export default {
  "grace": {
    "title": "Previous subscription needs attention",
    "hint": "The previous subscription is in a grace period or has an overdue renewal. Cancel it and refresh before recharging.",
    "action": "Cancel previous subscription and recheck",
    "confirm": "Cancel this account’s grace-period subscription? Grace-period access may end immediately. This only refreshes the account. Click redeem again yourself; no code is consumed and no payment is made automatically.",
    "pending": "The previous subscription has not been confirmed ended. Recheck the account without repeatedly cancelling or redeeming.",
    "done": "The previous subscription has ended and the account was refreshed. Review the plan and click redeem again.",
    "refreshFailed": "The result could not be confirmed. Recheck the account before trying another cancellation.",
    "processing": "Processing and refreshing…",
    "recheck": "Recheck account",
    "dismiss": "Not now",
    "confirmAction": "Confirm"
  },
  "common": {
    "back": "← Back",
    "backHome": "← Back to Home",
    "loading": "Loading...",
    "submitting": "Submitting...",
    "querying": "Querying...",
    "retry": "Search Again",
    "switchLight": "Switch to light mode",
    "switchDark": "Switch to dark mode"
  },
  "home": {
    "brand": "Recharge Portal",
    "brandSub": "Account Upgrade Service",
    "heroTitle": "Recharge & Account Upgrade Service",
    "heroSub": "Verify your account and CDK, then confirm — step by step",
    "flowTitle": "How It Works",
    "services": {
      "recharge": {
        "title": "Recharge",
        "en": "Recharge Portal",
        "cta": "Start Recharge",
        "p1": "Verify CDK code",
        "p2": "Submit session",
        "p3": "Confirm submission"
      },
      "batch": {
        "title": "Batch Redeem",
        "en": "Batch Redeem",
        "cta": "Start Batch",
        "p1": "Verify CDK list",
        "p2": "Import Excel sessions",
        "p3": "Match and submit in order"
      },
      "lookup": {
        "title": "CDK Status",
        "en": "CDK Status",
        "cta": "Check CDK",
        "p1": "Enter full CDK",
        "p2": "See if used",
        "p3": "Show recharge email"
      },
      "billing": {
        "title": "Billing",
        "en": "Billing Tool",
        "cta": "Check Billing",
        "p1": "Paste session",
        "p2": "Query billing info",
        "p3": "View subscription"
      }
    },
    "flows": {
      "submit": {
        "title": "Submit Flow",
        "s1": "Verify CDK — match plan and status",
        "s2": "Submit session — paste the JSON from chatgpt.com/api/auth/session",
        "s3": "Confirm — agree to terms and submit"
      },
      "batch": {
        "title": "Batch Redeem",
        "s1": "Verify CDKs — batch preview",
        "s2": "Import sessions — Excel/CSV auto-detect",
        "s3": "Match & submit — redeem in order and track progress"
      },
      "lookup": {
        "title": "CDK Status",
        "s1": "Enter CDK — full code",
        "s2": "Check status — used or not",
        "s3": "See email — which account was recharged"
      },
      "billing": {
        "title": "Billing Lookup",
        "s1": "Session input — paste your token",
        "s2": "Query billing — click to look up",
        "s3": "Result — shown after the query"
      }
    },
    "eyebrow": "SECURE CDK REDEEM DESK",
    "trustNote": "Encrypted in transit · used only for this recharge request",
    "statusLabel": "System service status",
    "systemOnline": "System online",
    "availability": "ALWAYS AVAILABLE",
    "serviceNav": "Service Index",
    "serviceNavSub": "Choose a service to enter its workflow",
    "flowSub": "Clear steps with traceable results",
    "status": {
      "api": "Live verify",
      "cdk": "Traceable",
      "ssl": "Secure link"
    }
  },
  "redeemTabs": {
    "single": "Redeem Now",
    "batch": "Batch Redeem",
    "lookup": "CDK Status",
    "billing": "Billing",
    "singleMeta": "Single Redeem",
    "batchMeta": "Batch Redeem",
    "lookupMeta": "CDK Status",
    "billingMeta": "Billing Check",
    "tutorial": "How It Works",
    "tutorialMeta": "Quick Start",
    "navLabel": "More services"
  },
  "batch": {
    "title": "Batch Redeem",
    "subtitle": "Verify CDKs → pair Session or email/password → submit and watch progress",
    "panelTitle": "Batch Redeem",
    "panelHint": "Verify CDKs → choose Session or email/password → match and submit in order",
    "cdkListLabel": "CDK list (one per line, max {max})",
    "cdkPlaceholder": "ZC-XXXXXXXXXX-XXXXXXXXXX\n…",
    "cdkRecognized": "{n} CDKs detected",
    "cdkQueueHint": "Large batches run with limited concurrency — ensure upstream capacity",
    "credMode": "Credential mode",
    "modeSession": "Session",
    "modeMailbox": "Email + password",
    "mailboxLabel": "Email/password list (one per line)",
    "mailboxPlaceholder": "email----password\nemail:password\nemail,password",
    "mailboxLinePlaceholder": "email----password or email:password",
    "mailboxRecognized": "{n} mailboxes detected",
    "mailboxImportBtn": "Import Excel / CSV / TXT (email + password)",
    "mailboxHint": "Supports mail.tm / Outlook. Format: email----password; Excel needs email + password columns",
    "mailboxPairHint": "Pairing: 1st valid CDK ↔ 1st mailbox, and so on. Live progress shows account and card last4.",
    "excelLabel": "Session Excel (optional)",
    "clearImport": "Clear import",
    "importing": "Parsing…",
    "imported": "{n} imported · click to replace",
    "importBtn": "Import Excel / CSV (auto-detect session column)",
    "excelHint": "Supports xlsx / csv. gptbuy format “email,email password,GPT password,token,session” uses the session column. Redeem needs full Session JSON (with sessionToken) or 5-part JWE — not bare Access Token",
    "verifying": "Verifying…",
    "verifyStart": "Verify batch and start",
    "verifyingKeys": "Verifying CDKs…",
    "statTotal": "Total",
    "statWait": "Awaiting credential",
    "statRun": "Running",
    "statOkFail": "OK / Fail",
    "currentOrdinal": "{n} / {total}",
    "remaining": "{n} left",
    "willUseAccount": "Using account:",
    "sessionPlaceholder": "Paste full Session JSON (must include sessionToken) or 5-part JWE; auto-filled after import",
    "submitting": "Submitting…",
    "submitNext": "Submit and continue",
    "autoSubmitting": "Auto-submitting…",
    "autoSubmit": "Auto-submit all (CDK×credential by order, {n} in pool)",
    "pairHint": "Pairing: 1st valid CDK ↔ 1st Excel session, and so on. Progress updates below after submit.",
    "allSubmitted": "All credentials submitted ({n})",
    "watchProgress": "Keep watching progress below",
    "exportOk": "Export successful accounts ({n})",
    "noValidKeys": "No valid CDKs to redeem",
    "liveProgress": "Live progress",
    "account": "Account",
    "card": "Card",
    "cardPending": "Last4 after card open",
    "reset": "Back · start over",
    "status": {
      "pending_verify": "Pending",
      "verify_ok": "Valid",
      "verify_fail": "Invalid",
      "waiting_session": "Need credential",
      "submitting": "Submitting",
      "processing": "Processing",
      "success": "Success",
      "failed": "Failed"
    }
  },
  "recharge": {
    "title": "Recharge",
    "subtitle": "Recharge Portal · Account recharge request",
    "steps": {
      "s1": "Verify CDK",
      "s2": "Credentials",
      "s3": "Confirm",
      "s4": "Result"
    },
    "step1Title": "Verify CDK Code",
    "cdkLabel": "CDK Code",
    "cdkValid": "✓ CDK valid",
    "planType": "Plan Type",
    "cdkTypesHint": "Supported CDK types: pro, 5x, 20x.",
    "verifying": "Verifying...",
    "next": "Next →",
    "prev": "← Previous",
    "step2Title": "Submit Session",
    "howToGetSession": "How to get your Session?",
    "sessionGuidePrefix": "After logging into ChatGPT, open in your browser",
    "sessionGuideSuffix": ", copy the full JSON returned, and paste it into the box below.",
    "sessionLabel": "Session JSON",
    "sessionHint": "Paste the full session JSON from chatgpt.com/api/auth/session",
    "sessionWarn": "⚠ Please paste the complete session JSON; it will be validated before submission",
    "step3Title": "Confirm & Submit",
    "sessionStatus": "Session Status",
    "sessionFilled": "✓ Provided",
    "agreePrefix": "I have read and agree to the",
    "terms": "Terms of Service",
    "and": "and",
    "privacy": "Privacy Policy",
    "submitSuccessTitle": "✓ Request submitted successfully!",
    "taskId": "Task ID",
    "submitSuccessHint": "Submitted. Use CDK Status to see whether the code is used and which email was recharged.",
    "confirmSubmit": "Confirm & Submit",
    "errInvalidCdk": "Invalid CDK",
    "errVerifyFailed": "Verification failed",
    "errCreateFailed": "Failed to create task",
    "errConfirmFailed": "Confirmation failed",
    "errNetwork": "Network error",
    "eyebrow": "SECURE RECHARGE PORTAL",
    "portalTitle": "GPT Recharge Portal",
    "portalSubtitle": "Secure · Fast · Simple · Fully traceable",
    "trustEncrypted": "Encrypted in transit",
    "trustRealtime": "Live progress",
    "trustTraceable": "Results anytime",
    "online": "System online",
    "encrypted": "Encrypted in transit",
    "workflowTitle": "Redeem & Recharge",
    "secureChannel": "Secure channel connected",
    "step1Subtitle": "Enter the full code to verify its plan and availability.",
    "verify": "Verify CDK",
    "previewValid": "Code verified. You can continue.",
    "cardHelpTitle": "Used only for this verification",
    "cardHelpBody": "Your CDK, credentials, and recharge result are never exposed publicly.",
    "step2Subtitle": "Paste a complete Session to validate the account and subscription.",
    "mailboxMode": "Email & Password",
    "sessionPrivacy": "Used only for this account check and recharge",
    "sessionPlaceholder": "Paste the complete Session JSON with sessionToken",
    "sessionInvalid": "Paste a complete Session JSON with sessionToken. Access Token alone is not supported.",
    "sessionCheckFailed": "Session validation failed. Sign in to ChatGPT again and obtain a fresh complete Session.",
    "emailLabel": "Login Email",
    "passwordLabel": "Email Password",
    "passwordPlaceholder": "Enter email password",
    "preflighting": "Checking...",
    "preflight": "Verify Account",
    "step3Subtitle": "Review the account and plan details before submitting the recharge.",
    "verifiedAccount": "VERIFIED ACCOUNT",
    "accountVerified": "Account verified",
    "planSatisfied": "Plan already active",
    "redeemNow": "Confirm Redeem",
    "resultTitle": "Recharge Progress",
    "resultSubtitle": "Keep this page open while the latest processing status syncs automatically.",
    "sideHints": {
      "s1": "This step validates the code and plan without consuming the CDK.",
      "s2": "Credentials are used only for this account check and recharge request.",
      "s3": "Review the target account, current subscription, and requested plan before submitting.",
      "s4": "Status refreshes automatically. Do not resubmit while the result is pending or under review."
    },
    "featureSecure": "Encrypted channel",
    "featureTraceable": "Traceable progress",
    "guideTitle": "How It Works",
    "guideSubtitle": "Complete your CDK recharge in four clear steps, with no portal account required.",
    "guide": {
      "g1": {
        "title": "Verify CDK",
        "body": "Enter the full code to confirm availability and the corresponding plan."
      },
      "g2": {
        "title": "Submit Credentials",
        "body": "Sign in to your GPT account in the browser, then copy and paste the complete Session JSON including sessionToken."
      },
      "g3": {
        "title": "Review Details",
        "body": "Check the target email, current plan, and subscription before submission."
      },
      "g4": {
        "title": "Track Result",
        "body": "Progress updates automatically and can be checked again through CDK Status."
      }
    },
    "footer": "Secure CDK Redeem Service",
    "targetPlan": "Target plan",
    "currentPlan": "Current plan",
    "subscriptionStatus": "Subscription status",
    "expiresAt": "Plan expires",
    "remainingTime": "Time remaining",
    "autoRenew": "Auto-renewal",
    "lastPaymentAt": "Last payment date",
    "lastPayment": "Last payment",
    "paymentMethod": "Payment method",
    "unavailable": "Not provided by the service",
    "accountUnavailable": "Account summary unavailable",
    "accountUnavailableHint": "You can still continue. The final result depends on system validation.",
    "syncing": "Syncing the latest progress",
    "processingEnded": "Processing has ended",
    "redeemAccount": "Recharge account",
    "bankCard": "Payment card",
    "cardPending": "Last four digits appear after card issuance",
    "redeemFailedHint": "This redemption was not successful. Check the code in CDK Status and retry only after confirming it can be submitted again.",
    "redeemCompleteHint": "Activation complete. Check the plan in your ChatGPT account.",
    "redeemAnother": "Redeem another code",
    "active": "Active",
    "expiredFree": "Expired / Free",
    "willRenew": "Renews automatically",
    "willNotRenew": "Does not renew",
    "paid": "Paid",
    "defaultPayment": "Default payment method",
    "expired": "Expired",
    "successHeadline": "Recharge successful",
    "failedHeadline": "Recharge unsuccessful",
    "reviewHeadline": "Under review. Please wait.",
    "queuedHeadline": "Submitted and queued",
    "processingHeadline": "Processing",
    "queuedStep": "Queued",
    "credentialStep": "Credential check",
    "pricingStep": "Pricing",
    "checkoutStep": "Card issuance / linking",
    "paymentStep": "Payment",
    "subscriptionStep": "Subscription activation",
    "invoiceStep": "Invoice",
    "renewalStep": "Renewal processing",
    "reconcileStep": "Reconciliation",
    "completedStep": "Completed",
    "processingStep": "Processing",
    "acceptProgress": "Accepted",
    "cardProgress": "Card / funds",
    "payProgress": "Payment",
    "doneProgress": "Activation",
    "enterCdk": "Enter a CDK code",
    "unavailableCdk": "The CDK is invalid or unavailable",
    "missingRedemptionToken": "No redemption_token was returned. Check the service Base configuration.",
    "mailboxRequired": "Enter your email and password",
    "preflightFailed": "Account check failed",
    "missingPreflightToken": "No preflight_token was returned",
    "redeemRejected": "Redemption was rejected",
    "sessionInstructions": "First sign in to your GPT account in the browser, then open {link} and copy the {json} (must include {token}).",
    "completeJson": "complete JSON",
    "freePlan": "Free",
    "renewalPlan": "Pro 20x renewal",
    "cardExpiry": "Card expires {date}",
    "satisfiedRenewing": "The account already has {plan} or higher, valid until {date} with auto-renewal. Cancel renewal and wait for expiry before buying again.",
    "satisfiedUntil": "The account already has {plan} or higher. You can buy again after {date}.",
    "satisfiedCurrent": "The account already has {plan} or higher, valid until {date}. A duplicate purchase is not available yet.",
    "satisfied": "The account already has {plan} or higher. A duplicate purchase is not available.",
    "daysHours": "{days}d {hours}h",
    "hoursMinutes": "{hours}h {minutes}m",
    "minutes": "{minutes}m",
    "displaySettings": "Display settings",
    "close": "Close"
  },
  "cdkLookup": {
    "title": "CDK Status",
    "subtitle": "Check whether a CDK is used and which email was recharged (no token)",
    "queryTitle": "Enter CDK",
    "queryHint": "Enter the full CDK. Only use-status and recharge email are returned — never session/token.",
    "modeSingle": "Single",
    "modeBatch": "Batch",
    "batchHint": "One per line, or separated by spaces/commas. Max {max} per query. Never returns session/token.",
    "batchLabel": "CDK list",
    "batchPlaceholder": "SXC-XXXX-XXXX-XXXX-XXXX\nSXC-YYYY-YYYY-YYYY-YYYY",
    "batchRecognized": "{n} CDKs detected",
    "batchTruncated": "Over the limit — only the first {max} will be queried",
    "batchQueryBtn": "Check all",
    "batchEmpty": "Paste at least one CDK first",
    "copyEmails": "Copy used emails",
    "exportCsv": "Export CSV",
    "copied": "Copied",
    "copyFail": "Copy failed",
    "summaryUsed": "Succeeded {n}",
    "summaryFailed": "Failed {n}",
    "summaryUnused": "Unused {n}",
    "summaryProcessing": "Processing {n}",
    "summaryUnknown": "Not found {n}",
    "cdkLabel": "CDK Code",
    "cdkPlaceholder": "SXC-XXXX-XXXX-XXXX-XXXX",
    "queryBtn": "Check CDK Status",
    "resultTitle": "Result",
    "cdkCode": "CDK",
    "useStatus": "Result",
    "rechargeEmail": "Recharge email",
    "emailEmpty": "—",
    "plan": "Plan",
    "usedAt": "Used at",
    "queryOther": "Check another CDK",
    "resubmit": "Resubmit",
    "goRedeem": "Redeem",
    "msgUsed": "This CDK was used successfully.",
    "msgFailed": "This CDK failed.",
    "msgUnused": "This CDK has not been used yet.",
    "msgProcessing": "This CDK redeem is in progress.",
    "errNotFound": "CDK not found",
    "errNetwork": "Network error, please retry",
    "status": {
      "unused": "Unused",
      "used": "Succeeded",
      "failed": "Failed",
      "disabled": "Disabled",
      "expired": "Expired",
      "processing": "Processing",
      "unknown": "Unknown"
    }
  },
  "dashboard": {
    "title": "Billing Tool",
    "subtitle": "Billing Tool · Query account subscription and billing",
    "step1Title": "Paste Session to Query",
    "hint": "Paste the session JSON or access token you want to check.",
    "inputLabel": "Session JSON or access token",
    "inputPlaceholder": "Paste session JSON or access token",
    "inputExample": "e.g. {\"access_token\":\"sk-xxx\"} or paste the token directly",
    "queryBtn": "Query Billing",
    "resultTitle": "Billing Result",
    "accountInfo": "Account Info",
    "email": "Email",
    "subStatus": "Subscription",
    "currentPlan": "Current Plan",
    "billingInfo": "Billing Info",
    "billingAmount": "Amount",
    "currency": "Currency",
    "nextBilling": "Next Billing Date",
    "queryOther": "Query Another Account",
    "notFoundTitle": "No billing found for this session",
    "notFoundHint": "Please check whether the session is correct",
    "msgActive": "✓ Subscription active, account is in good standing",
    "msgInactive": "⚠ Subscription inactive, please check billing info",
    "msgExpired": "✗ Subscription expired, please update payment info",
    "errQueryFailed": "Query failed",
    "errNetwork": "Network error, please try again",
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "expired": "Expired"
    }
  },
  "login": {
    "title": "Admin Login",
    "subtitle": "Log in to the admin console for CDK issue, redeem recon and site settings.",
    "username": "Username",
    "usernamePlaceholder": "Enter username",
    "password": "Password",
    "passwordPlaceholder": "Enter password",
    "loginBtn": "Sign In",
    "loggingIn": "Signing in...",
    "errLoginFailed": "Login failed",
    "errNetwork": "Network error, please try again later"
  },
  "notFound": {
    "title": "Page Not Found",
    "home": "Back to Home"
  }
}
